import { render, staticRenderFns } from "./ManualRetrievalPage.vue?vue&type=template&id=2591d520&scoped=true&"
import script from "./ManualRetrievalPage.vue?vue&type=script&lang=js&"
export * from "./ManualRetrievalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591d520",
  null
  
)

export default component.exports